<template>
  <OnboardingModal
    ref="googleadsModal"
    :title="$t('components.connectGoogleAdsSS.connectGoogleAds')"
    large
    @open="$emit('modalAction', MARKETING_PLATFORMS.AMAZONADS, 'open')"
    @close="$emit('modalAction', MARKETING_PLATFORMS.AMAZONADS, 'close')"
  >
    <ConnectedAccountModalAdsLayout>
      <ol>
        <li class="m-b-10">
          <i18n-t keypath="components.connectGoogleAdsSS.loginInstruction">
            <template #googleAdsAccount>
              <a target="_blank" href="https://ads.google.com/">
                {{ $t('components.connectGoogleAdsSS.googleAdsAccount') }}
              </a>
            </template>
          </i18n-t>
        </li>
        <li class="m-b-10">
          {{ $t('components.connectGoogleAdsSS.clickHelpInstruction') }}
        </li>
        <li class="m-b-10">
          <i18n-t
            keypath="components.connectGoogleAdsSS.findCustomerIDInstruction"
          >
            <template #customerID>
              <span>
                {{ $t('components.connectGoogleAdsSS.customerID') }}
              </span>
            </template>
          </i18n-t>
        </li>
        <li class="m-b-10">
          <i18n-t
            keypath="components.connectGoogleAdsSS.enterCustomerIDInstruction"
          >
            <template #customerID>
              <span>
                {{ $t('components.connectGoogleAdsSS.customerID') }}
              </span>
            </template>
          </i18n-t>
          <div>
            <div class="m-b-20">123-456-7890</div>
          </div>
          <ConnectedAccountInputWithEyebrow
            v-model="googleadsAuth.customerId"
            name="googleads-customer-id"
            type="text"
            autofill="off"
            :placeholder="
              $t('components.connectGoogleAdsSS.googleAdsCustomerID')
            "
            :error-msg="$t('common.errors.mandatory')"
            required
            class="m-b-20"
            :validate-on-blur="validateOnBlur"
          />
          <div class="m-b-10">
            <OnboardingButton
              :text="$t('components.connectGoogleAdsSS.connect')"
              class="m-b-20"
              theme="modals"
              @click="handleSubmit"
            />
          </div>
        </li>
      </ol>
    </ConnectedAccountModalAdsLayout>
  </OnboardingModal>
</template>
<script>
import { MARKETING_PLATFORMS } from '@/data/platforms';
import { clickTrackingMixin } from '@/utils/vue-mixins';
import { validateChildren } from '@/composables/validation';

import OnboardingModal from '@/components/modals/OnboardingModal.vue';
import OnboardingButton from '@/components/buttons/OnboardingButton.vue';
import ConnectedAccountInputWithEyebrow from '@/pages/connected-accounts/components/ConnectedAccountInputWithEyebrow.vue';
import ConnectedAccountModalAdsLayout from '@/pages/connected-accounts/components/ConnectedAccountModalAdsLayout.vue';

export default {
  components: {
    ConnectedAccountInputWithEyebrow,
    OnboardingModal,
    OnboardingButton,
    ConnectedAccountModalAdsLayout,
  },
  mixins: [clickTrackingMixin],
  computed: {
    MARKETING_PLATFORMS: () => MARKETING_PLATFORMS,
  },
  setup() {
    const { hasError } = validateChildren();
    return {
      hasError,
    };
  },
  data() {
    return {
      validateOnBlur: false,
      googleadsAuth: {},
    };
  },
  methods: {
    /** @public */
    open() {
      this.trackClick('googleads');
      this.$refs.googleadsModal.open();
    },
    async handleSubmit() {
      this.validateOnBlur = true;

      const error = await this.hasError();
      if (error) {
        this.$emit('error');
        return;
      }

      this.$refs.googleadsModal?.close();
      this.$emit('submit', this.googleadsAuth.customerId);
    },
  },
};
</script>
